import { createAction } from 'redux-act';

export const selectSubscriptionType = createAction('Select subscription type');
export const updateSubscriptionConfiguration = createAction('Updated configuration');
export const changeSubscriptionStep = createAction('Change subscription step');
export const updateReceivers = createAction('Update receivers');
export const saveReceivers = createAction('Finished editing receivers');
export const createSubscription = createAction('Create subscription');
export const clearSubscriptionData = createAction('Clear subscription data');
export const submitDiscount = createAction('Submit discount');
